module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/teshlumon/open-receipts/open-receipts.component.css
// module id = ./src/app/admin/teshlumon/open-receipts/open-receipts.component.css
// module chunks = main